
import { User, signOut, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth, useAuth } from '../contexts/authContext';
import { useState } from "react";
import { addUser } from "../firestore/db";
import { HanimcilarUser } from "../firestore/firestore-types";
import { Timestamp } from "firebase/firestore";
import { DEFAULT_AVATAR_URL } from "../utils/image";
import "../styles/authpage.css";
export const logOut = async () => {
  await signOut(auth)
}

const AuthStatus = ({ user }: { user: User | null }) => {
  return (
    <div className="auth-status-wrapper">
    <p className="idontcare-p">{user ? `Signed in as ${user.displayName || user.email}` : `You are not signed in.`}</p>
    {!user && <><p className="auth-note-bold">Sign in to create and share your own themed photo albums.</p><p className="auth-note">Your account and album access are managed through Firebase Authentication, owned by Google.</p></>}
    {user &&
        <button className="logout-button" onClick={() => {
        logOut().then(()=>{
          console.log("logged out of account:", user?.displayName);
        })
        }}>Log out
      </button>}
    </div>
  );
};
interface AuthPageProps {
    user: User | null;
  }
const AuthPage = (props: AuthPageProps) => {
    const user = useAuth() || props.user;
    const [isSigningIn, setIsSigningIn] = useState(false);
    const [authError, setAuthError] = useState<string | null>(null);

    const signInWithGoogle = async () => {
        const provider = new GoogleAuthProvider();
        provider.addScope('https://www.googleapis.com/auth/userinfo.email');
        provider.addScope('https://www.googleapis.com/auth/userinfo.profile');
        provider.addScope('https://www.googleapis.com/auth/drive');
        provider.addScope('openid');

        setAuthError(null);
        setIsSigningIn(true);
        try {
            const result = await signInWithPopup(auth, provider);
            const credential = GoogleAuthProvider.credentialFromResult(result);
            const token = credential?.accessToken;
            const signedUser = result.user;

            console.log(signedUser);
            console.log(signedUser.email, signedUser.uid, signedUser.displayName);
            console.log(token);

            const hanimcilarUser: HanimcilarUser = {
                email: signedUser.email!,
                name: signedUser.displayName!,
                uid: signedUser.uid,
                paymentInfo: [],
                photoUrl: signedUser.photoURL || DEFAULT_AVATAR_URL,
                address: "",
                created: Timestamp.now(),
                albums: [],
                collaboratorAlbums: [],
            }

            await addUser(hanimcilarUser).then((docRefId) => {
                console.log("user added to firestore users collection with id: ", docRefId);
            });
        } catch (error: any) {
            const errorCode = error.code;
            const errorMessage = error.message;
            const email = error.email;
            const credential = GoogleAuthProvider.credentialFromError(error);
            console.log("error", errorCode);
            console.log("error", errorMessage);
            console.log(email);
            console.log(credential);
            setAuthError("Sign in failed. Please try again in a moment.");
        } finally {
            setIsSigningIn(false);
        }
    }

    return (
            <main className="signup-page-wrapper">
              <section className="auth-shell">
                <aside className="auth-hero-panel">
                  <header className="auth-hero-header" aria-label="Hanimcilar intro">
                    <p className="auth-eyebrow">
                      <span className="auth-eyebrow-dot" aria-hidden="true"></span>
                      Hanimcilar
                    </p>
                    <p className="auth-header-note">Polaroid Album Project</p>
                  </header>
                  <h1>Turn your moments into a shareable polaroid story.</h1>
                  <p className="auth-hero-copy">
                    Originally crafted as a New Year gift, Hanimcilar is now a public album platform where anyone can build dynamic polaroid boards with captions and dates.
                  </p>
                  <ul className="auth-benefits">
                    <li>Create themed polaroid albums with text and date details.</li>
                    <li>Share with your loved ones, friends, or the world.</li>
                    <li>Control album privacy and invite collaborators.</li>
                  </ul>
                </aside>

                <section className="auth-card" aria-label="Sign in panel">
                  <h2>Sign in to start your album</h2>
                  <p className="auth-card-copy">Use Google to continue. Hanimcilar uses Firebase Auth and can request Google Drive access for picker-based uploads.</p>
                  <div className="auth-meta" aria-hidden="true">
                    <span>Firebase Auth</span>
                    <span>Firestore + Storage</span>
                    <span>Google Drive Picker</span>
                  </div>
                  <button
                    className="signin-google-button"
                    onClick={signInWithGoogle}
                    disabled={isSigningIn}
                  >
                    <img
                      decoding="async"
                      src='https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_"G"_logo.svg'
                      alt="Google logo"
                      className="google-logo"
                    />
                    {isSigningIn ? "Connecting to Google..." : "Continue with Google"}
                  </button>
                  {authError && <p className="auth-error" role="alert">{authError}</p>}

                  <AuthStatus user={user} />
                </section>
              </section>
            </main>
    );
};

export default AuthPage;